export enum EventType {
  Challenge = "challenge",
  ExternalEvent = "external_event",
  MonthlyMeeting = "monthly_meeting",
  SpecialEvent = "special_event",
  TurnersTalk = "turners_talk",
  WoodRaffle = "wood_raffle",
}

export function getEventTypeName(type: EventType): string {
  switch (type) {
    case EventType.Challenge:
      return "Quarterly Challenge";
    case EventType.ExternalEvent:
      return "";
    case EventType.MonthlyMeeting:
      return "Monthly Meeting";
    case EventType.SpecialEvent:
      return "Special Event";
    case EventType.TurnersTalk:
      return "Turners Talk";
    case EventType.WoodRaffle:
      return "Wood Raffle";
    default:
      return "Event";
  }
}
